import vue from 'vue';
import Message from './message';
const MsgClass = vue.extend(Message);
let j_message = document.createElement('div');
const instance = new MsgClass();
instance.$mount(j_message);
document.body.appendChild(instance.$el);

const MsgMain = function (text, duration = 2000) {
  instance.text = text;
  instance.isShow = true;
  setTimeout(() => {
    instance.isShow = false;
  }, duration);
};
function Msg() {
  vue.prototype.$msg = MsgMain;
}

export default Msg;



// WEBPACK FOOTER //
// ./src/components/message/config.js